import { RegistrationSuccessCard } from '@shared-components/modules';
import React from 'react';

const RegistrationSuccess: React.FC = () => {
  return <RegistrationSuccessCard />;
};

export default RegistrationSuccess;
